/**
 * Navigation only: no account, tenant, workspace or entitlement inputs.
 * Cartiq stays on its current origin; Support handles its own authentication.
 * Do not add TuoIQ until this app has a verified route and availability gate.
 */
export const APP_SWITCHER_LINKS = [
  {
    id: 'cartiq',
    name: 'Cartiq',
    href: '/',
    description: 'Commerce workspace',
    current: true,
    external: false,
  },
  {
    id: 'support',
    name: 'Tuolen Support',
    href: 'https://app.tuolen.com',
    description: 'Opens in a new tab',
    current: false,
    external: true,
  },
] as const;
